itsoftApp.createModule("scrollParallax", function () {
  var module = this;

  var initParallax = function () {
    itsoftApp.loadScript("/assets/scripts/rellax/rellax.min.js", function () {
      if (document.querySelectorAll(".advantages .page__wave").length !== 0) {
        new Rellax(".advantages .page__wave", {
          relativeToWrapper: true,
          wrapper: ".advantages__top",
          round: true,
          vertical: true,
          horizontal: false,
        });
      }

      if (document.querySelectorAll(".instructions .page__wave").length !== 0) {
        new Rellax(".instructions .page__wave", {
          relativeToWrapper: true,
          wrapper: ".instructions",
          round: true,
          vertical: true,
          horizontal: false,
        });
      }

      var parallaxClassList = [
        ".js-parallax--top .js-page-wave",
        ".js-parallax--promo .js-page-wave",
      ];

      try {
        for (var index = 0; index < parallaxClassList.length; index++) {
          var element = parallaxClassList[index];
          var wave = document.querySelector(element);

          if (wave) {
            new Rellax(element, {
              relativeToWrapper: true,
              wrapper: wave.parentElement.parentElement,
              round: true,
              vertical: true,
              horizontal: false,
            });
          }
        }
      } catch (error) {
        console.error("scrollParallax error:", error);
      }
    });
  };

  module.callback = initParallax;
});
